import { render, staticRenderFns } from "./projectsStats.vue?vue&type=template&id=29725286"
import script from "./projectsStats.vue?vue&type=script&lang=js"
export * from "./projectsStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports